import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Session is carried entirely in the HttpOnly `access_token` cookie set by
// POST /api/auth/login. We never read or write the token in JavaScript, so
// XSS cannot lift the admin session.
const api = axios.create({ baseURL: API, withCredentials: true });

// One-time migration: scrub any legacy JWT left in localStorage from older
// builds. Safe to run on every page load (idempotent, no-op if absent).
try { localStorage.removeItem("gtes_token"); } catch (_) { /* storage disabled */ }

export default api;

// Turn a Pydantic `loc` array (e.g. ["body", "earnings", 0, "name"]) into a
// human-friendly field reference like "earnings row 1 → name". We skip the
// leading "body" segment which is a FastAPI implementation detail.
function locToLabel(loc) {
  if (!Array.isArray(loc) || loc.length === 0) return "";
  const parts = loc[0] === "body" ? loc.slice(1) : loc.slice();
  const out = [];
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i];
    if (typeof p === "number") out.push(`row ${p + 1}`);
    else out.push(String(p).replace(/_/g, " "));
  }
  return out.join(" → ");
}

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    // Deduplicate identical (loc, msg) pairs and prefix with the field path so
    // users see "earnings row 2 → name: Field required" instead of a wall of
    // "Field required Field required …".
    const seen = new Set();
    const lines = [];
    for (const x of d) {
      const label = locToLabel(x?.loc);
      const msg = x?.msg || JSON.stringify(x);
      const key = `${label}::${msg}`;
      if (seen.has(key)) continue;
      seen.add(key);
      lines.push(label ? `${label}: ${msg}` : msg);
    }
    return lines.join(" · ");
  }
  return String(d);
}
